import { createSelector } from 'reselect'

import { CoreRootState } from '../coreRoot.reducer'

export const getDeleteRequestFetching = createSelector(
  (state: CoreRootState) => state.dashboardStore.deleteRequestFetching,
  (state) => state,
)

export const getFacebookPage = createSelector(
  (state: CoreRootState) => state.dashboardStore.facebookPage,
  (state) => state,
)

export const selectFacebookPostByPostId = (networkPostId: string | undefined) =>
  (state: CoreRootState) =>
    networkPostId ? state.dashboardStore.facebookPostsById[networkPostId] : undefined

export const selectInstagramPostByPostId = (networkPostId: string | undefined) =>
  (state: CoreRootState) =>
    networkPostId ? state.dashboardStore.instagramPostsById[networkPostId] : undefined

export const getInstagramPage = createSelector(
  (state: CoreRootState) => state.dashboardStore.instagramPage,
  (state) => state,
)

export const getLinkedInPage = createSelector(
  (state: CoreRootState) => state.dashboardStore.linkedInPage,
  (state) => state,
)

export const getCalendarData = createSelector(
  (state: CoreRootState) => state.dashboardStore.calendarData,
  (state) => state,
)

export const getTemplates = createSelector(
  (state: CoreRootState) => state.dashboardStore.templates,
  (state) => state,
)

export const getAboTopics = createSelector(
  (state: CoreRootState) => state.dashboardStore.aboTopics,
  (state) => state,
)

export const getGlobalPosts = createSelector(
  (state: CoreRootState) => state.dashboardStore.globalPosts,
  (state) => state,
)

export const getUpdatedPostTemplate = createSelector(
  (state: CoreRootState) => state.dashboardStore.updatedPostTemplate,
  (state) => state,
)

export const getPostingStatus = createSelector(
  (state: CoreRootState) => state.dashboardStore.postingStatus,
  (state) => state,
)

export const getAboSettings = createSelector(
  (state: CoreRootState) => state.dashboardStore.aboSettings,
  (state) => state,
)

export const getCoreFBPageSettings = createSelector(
  (state: CoreRootState) => state.dashboardStore.coreFBPageSettings,
  (state) => state,
)

export const getCoreInstaPageSettings = createSelector(
  (state: CoreRootState) => state.dashboardStore.coreInstaPageSettings,
  (state) => state,
)

export const getReNewPageSettings = createSelector(
  (state: CoreRootState) => state.dashboardStore.reNewPageSettings,
  (state) => state,
)

export const getQuizData = createSelector(
  (state: CoreRootState) => state.dashboardStore.selectedMultipleChoiceQuiz,
  (state) => state,
)

export const getReloadCalendar = createSelector(
  (state: CoreRootState) => state.dashboardStore.reloadCalendar,
  (state) => state,
)

export const getDetailPosts = createSelector(
  (state: CoreRootState) => state.dashboardStore.detailPosts,
  (state) => state,
)

export const getNetworkContentPage = createSelector(
  (state: CoreRootState) => state.dashboardStore.networkContentPage,
  (state) => state,
)

export const getPageMasterData = createSelector(
  (state: CoreRootState) => state.dashboardStore.pageMaster,
  (state) => state,
)

export const getPageOwnersData = createSelector(
  (state: CoreRootState) => state.dashboardStore.pageOwners,
  (state) => state,
)

export const getUrlInformation = createSelector(
  (state: CoreRootState) => state.dashboardStore.pageResource,
  (state) => state,
)
